import $ from "jquery";

export const init = () => {
    const $btnOpenSearch = $(".btn-search");
    $btnOpenSearch.click(function (e) {
        e.preventDefault();
        $('body').addClass("search-open");
    });

    const $btnCloseSearch = $(".search-close");
    $btnCloseSearch.click(function (e) {
        e.preventDefault();
        $('body').removeClass("search-open");
    });

    $(window).on('load resize', function () {
        var windowWidth = window.innerWidth;
        if (windowWidth >= 992) {
            $('body').removeClass("search-open");
        }
    });
};
